import React, { useState } from "react";
import Link from "@/utils/link";
import Image from "next/legacy/image";
import useSWR, { SWRConfig } from "swr";
import moment from "moment";

import HomeHeader from "@/components/home/HomeHeader";
import { fetchGraphql } from "@/utils/query";
import { imageLoader, removeExt } from "@/utils/image";

import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import Breadcrumbs from "@/components/common/Breadcrumbs";

const fetcher = (url) => fetch(url).then((res) => res.json());

const NewsCard = ({ article, imageHeight = "h-32 w-32" }) => {
    return (
        <div className="hover:bg-gray-100">
            <Link href={"/newsroom/" + article.articleId}>
                <a className="flex">
                    {article.mainImageUrl ? (
                        <div className={`relative ${imageHeight} `}>
                            <Image
                                loader={imageLoader}
                                src={removeExt(article.mainImageUrl) + ".md.jpg"}
                                alt={article.title}
                                layout="fill"
                                objectFit="cover"
                                objectPosition="center"
                                priority
                                unoptimized={false}
                            />
                        </div>
                    ) : (
                        <div className={`w-full ${imageHeight} bg-gray-200`}></div>
                    )}

                    <div className="flex flex-col justify-between w-full px-8">
                        <div>
                            <h3 className="text-xl font-headline font-bold text-primary-500">
                                {article.title}
                            </h3>

                            <h4 className="text-sm font-bold">
                                {moment(article.date).format("MMMM DD, YYYY")}
                            </h4>

                            <p className="mt-4 line-clamp-3">{article.description}</p>
                        </div>

                        <div className="text-sm font-extrabold uppercase text-primary-500">
                            Read More
                        </div>
                    </div>
                </a>
            </Link>
        </div>
    );
};

const ArticlePage = ({ fallback }) => {
    return (
        <SWRConfig value={{ fallback }}>
            <ArticlePageWithInitialData />
        </SWRConfig>
    );
};

const ArticlePageWithInitialData = () => {
    const { data } = useSWR("/api/newsroom", fetcher);

    return (
        <div className="h-screen bg-gray-50">
            <HomeHeader fixed />

            <div className="container mx-auto pt-16 sm:pt-20 pb-4 px-16">
                <Breadcrumbs links={[{ name: "Newsroom", href: "/newsrooms" }]} />
            </div>

            <div className="">
                <div className="hidden sm:block w-full py-16 bg-primary-500">
                    <div className="container mx-auto px-4 sm:px-16">
                        <h1 className="text-3xl sm:text-5xl text-white font-headline font-bold">
                            Newsroom
                        </h1>
                    </div>
                </div>

                <div className="container mx-auto mt-8 mb-12 px-4 sm:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                        <div className="col-span-3 flex flex-col space-y-8">
                            {data
                                .sort((a, b) =>
                                    a.date && b.date
                                        ? new Date(b.date) - new Date(a.date)
                                        : 0
                                )
                                .map((article) => (
                                    <NewsCard
                                        key={article.articleId}
                                        article={article}
                                        imageHeight="h-48 w-48"
                                    />
                                ))}
                        </div>

                        <div>
                            {/*<h2 className="text-primary-500 text-xl font-headline font-bold">
                                Sign Up for Updates
                            </h2>

                                <p>Newsletter ??????</p>*/}

                            <h2 className="text-primary-500 text-xl font-headline font-bold">
                                Press Inquiries
                            </h2>

                            <p className="mt-4">
                                Please contact{" "}
                                <a
                                    href="mailto:press@purpledoorfinders.com"
                                    className="text-primary-500 underline hover:font-bold"
                                >
                                    press@purpledoorfinders.com
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

//export const getStaticProps = async () => {
export const getServerSideProps = async () => {
    const result = await fetchGraphql(`
        query {
            articles {
                articleId
                _createdAt
                _updatedAt
                type
                newsroomType
                title
                date
                description
                mainImageUrl
                keywords
                topic
                author_link {
                    name
                }
            }
        }
    `);

    return {
        props: {
            fallback: {
                "/api/newsroom":
                    result.data.articles && result.data.articles.length > 0
                        ? result.data.articles
                              .filter(
                                  (a) =>
                                      a.newsroomType === "Newsroom" ||
                                      a.newsroomType === "Both"
                              )
                              .sort(
                                  (a, b) => new Date(b._createdAt) - new Date(a._createdAt)
                              )
                        : [],
            },
        },
    };
};

export default ArticlePage;
